// extracted by mini-css-extract-plugin
module.exports = {"card_container":"styles_card_container__2t68M","member_details":"styles_member_details__2IrMn"};